import { render, staticRenderFns } from "./InvestorOnboardingMerchantContractV2.vue?vue&type=template&id=1a8a4f3e&scoped=true&"
import script from "./InvestorOnboardingMerchantContractV2.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingMerchantContractV2.vue?vue&type=script&lang=js&"
import style0 from "./InvestorOnboardingMerchantContractV2.vue?vue&type=style&index=0&id=1a8a4f3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8a4f3e",
  null
  
)

export default component.exports